import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import './Layout.css'

export default function Layout() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  function handleLogout() {
    logout()
    navigate('/login')
  }

  if (!user) {
    navigate('/login')
    return null
  }

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar-left">
         <div className="topbar-logo">
            <img src="/GL_sansvague_noir_carre_65.png" alt="Groupe Leclair" style={{height:'32px', width:'auto'}} />
          </div>
          <nav className="topbar-nav">
            <NavLink to="/dashboard" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
              Tableau de bord
            </NavLink>
            <NavLink to="/saisie" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
              Saisie journalière
            </NavLink>
            <NavLink to="/comparatifs" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
              Comparatifs
            </NavLink>
            <NavLink to="/journal" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
              Journal
            </NavLink>
            <NavLink to="/kpis" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
              KPIs
            </NavLink>
            {user.isAdmin && (
              <NavLink to="/admin" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>
                Admin
              </NavLink>
            )}
          </nav>
        </div>
        <div className="topbar-right">
          <span className="topbar-user">{user.label}</span>
          <button className="topbar-logout" onClick={handleLogout}>Déconnexion</button>
        </div>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}
